import type { ClaimStatus } from "s12-library/types";

interface IClaimStatus {
  underReview: ClaimStatus;
  approved: ClaimStatus;
  paid: ClaimStatus;
  onHold: ClaimStatus;
  rejected: ClaimStatus;
  duplicated: ClaimStatus;
}

export const CLAIM_STATUS: IClaimStatus = {
  underReview: "under_review",
  approved: "approved",
  paid: "approved_and_paid",
  onHold: "on_hold",
  rejected: "rejected",
  duplicated: "duplicated",
};
